import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  Paper,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  ButtonGroup,
  SwipeableDrawer,
} from "@mui/material";
import { AccountCircle } from "@mui/icons-material";
import {
  addDevProject,
  deleteDevProject,
  getDevProject,
  getDevProjects,
  updateDevProject,
} from "../../features/Dev/projectSlice";
import { useDispatch, useSelector } from "react-redux";

const Projects = () => {
  const [createModal, setCreateModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const { projects, project, errors } = useSelector((state) => state.project);
  const [addLogs, setAddLogs] = useState({
    id: "",
    project: "",
    tech_stack: "",
    live_link: "",
    github_link: "",
    description: "",
    project_cover: "",
  });

  const [editLogs, setEditLogs] = useState({
    id: project?.id,
    project: project?.attributes.project,
    tech_stack: project?.attributes.tech_stack,
    live_link: project?.attributes.live_link,
    github_link: project?.attributes.github_link,
    description: project?.attributes.description,
    project_cover: project?.attributes.project_cover,
  });

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDevProjects());
  }, []);

  //   ? add project modal toggle
  const handleOpen = () => {
    setCreateModal(true);
  };
  const handleClose = () => {
    setCreateModal(false);
  };

  //   ? edit project modal toggle
  const handleOpenEdit = (id) => {
    dispatch(getDevProject(id));
    setEditLogs({
      id: project?.id,
      project: project?.attributes.project,
      tech_stack: project?.attributes.tech_stack,
      live_link: project?.attributes.live_link,
      github_link: project?.attributes.github_link,
      description: project?.attributes.description,
      project_cover: project?.attributes.project_cover,
    });
    setEditModal(true);
    console.log(editLogs);
  };
  const handleCloseEdit = () => {
    setEditLogs({
      id: "",
      project: "",
      tech_stack: "",
      live_link: "",
      github_link: "",
      description: "",
      project_cover: "",
    });
    setEditModal(false);
  };

  //   ? handle add project change
  const handleAddProjectChange = (e) => {
    setAddLogs({
      ...addLogs,
      [e.target.name]: e.target.value,
    });
  };

  // ?  handle add project submit
  const handleAddProjectSubmit = (e) => {
    e.preventDefault();
    dispatch(addDevProject(addLogs));
    dispatch(getDevProjects());
  };

  //   ? handle edit project change

  const handleEditProjectChange = (e) => {
    setEditLogs({
      ...editLogs,
      id: editLogs?.id,
      [e.target.name]: e.target.value,
    });
  };

  //   ? handle update submit
  const handleEditProjectSubmit = (e) => {
    e.preventDefault();
    dispatch(updateDevProject(editLogs));
    // dispatch(getDevProjects());
    handleCloseEdit();
  };

  const handleDeleteDevProject = (id) => {
    dispatch(deleteDevProject(id));
    // dispatch(getDevProjects());
  };

  return (
    <>
      <Container
        maxWidth="md"
        sx={{
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          // height: "80vh",
        }}
      >
        <TableContainer component={Paper} elevation={4}>
          <Table sx={{ minWidth: "100%" }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Id</TableCell>
                <TableCell align="right">Name</TableCell>
                <TableCell align="right">Tech Stack</TableCell>
                <TableCell align="right">Live Link</TableCell>
                <TableCell align="right">GitHub Link</TableCell>
                <TableCell align="right">
                  Action{" "}
                  <Button variant="outlined" onClick={handleOpen}>
                    create{" "}
                  </Button>{" "}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {projects.length > 0 &&
                projects.map((project) => (
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    key={project.id}
                  >
                    <TableCell component="th" scope="row">
                      {project?.id}
                    </TableCell>
                    <TableCell align="right">
                      {project?.attributes?.project}
                    </TableCell>
                    <TableCell align="right">
                      {project?.attributes?.tech_stack}{" "}
                    </TableCell>
                    <TableCell align="right">
                      {project?.attributes?.live_link}
                    </TableCell>
                    <TableCell align="right">
                      {project?.attributes?.github_link}
                    </TableCell>
                    <TableCell align="right">
                      <ButtonGroup size="large" aria-label="large button group">
                        <Button
                          color="primary"
                          onClick={() => handleOpenEdit(project?.id)}
                        >
                          Edit
                        </Button>
                        <Button
                          onClick={() => handleDeleteDevProject(project?.id)}
                          color="error"
                        >
                          Delete
                        </Button>
                      </ButtonGroup>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
      <SwipeableDrawer anchor="bottom" open={createModal} onClose={handleClose}>
        <Container>
          <DialogTitle>Add Project</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Please fill in all appropraite filds to add a new project
            </DialogContentText>
            <Box component="form" onSubmit={handleAddProjectSubmit}>
              <Paper p={2} elevation={2}>
                <Box sx={{ p: 2 }}>
                  <Box py={2}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <AccountCircle
                            sx={{ color: "action.active", mr: 1, my: 0.5 }}
                          />
                          <TextField
                            //   id="input-with-sx"
                            label="Project Name"
                            variant="standard"
                            name="project"
                            value={addLogs.project}
                            fullWidth
                            onChange={handleAddProjectChange}
                            helperText={errors?.project}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <AccountCircle
                            sx={{ color: "action.active", mr: 1, my: 0.5 }}
                          />
                          <TextField
                            id="input-with-sx"
                            label="Tech Stack"
                            variant="standard"
                            name="tech_stack"
                            fullWidth
                            onChange={handleAddProjectChange}
                            helperText={errors?.tech_stack}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <AccountCircle
                            sx={{ color: "action.active", mr: 1, my: 0.5 }}
                          />
                          <TextField
                            //   id="input-with-sx"
                            label="live link "
                            variant="standard"
                            name="live_link"
                            fullWidth
                            type="url"
                            onChange={handleAddProjectChange}
                            helperText={errors?.live_link}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <AccountCircle
                            sx={{ color: "action.active", mr: 1, my: 0.5 }}
                          />
                          <TextField
                            //   id="input-with-sx"
                            label="github link"
                            variant="standard"
                            name="github_link"
                            fullWidth
                            type="url"
                            onChange={handleAddProjectChange}
                            helperText={errors?.github_link}
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <AccountCircle
                            sx={{ color: "action.active", mr: 1, my: 0.5 }}
                          />
                          <TextField
                            //   id="input-with-sx"
                            label="project cover picture"
                            variant="standard"
                            name="project_cover"
                            fullWidth
                            type="url"
                            onChange={handleAddProjectChange}
                            helperText={errors?.project_cover}
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          // id="filled-textarea"
                          label="project discription"
                          placeholder="enter description"
                          multiline
                          variant="filled"
                          name="description"
                          fullWidth
                          onChange={handleAddProjectChange}
                          helperText={errors?.description}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Button variant="outlined" size="large" type="submit">
                      Add Project
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="error" variant="outlined">
              close
            </Button>
          </DialogActions>
        </Container>
      </SwipeableDrawer>

      <SwipeableDrawer
        anchor="bottom"
        open={editModal}
        onClose={handleCloseEdit}
      >
        <Container>
          <DialogTitle>Edit Project </DialogTitle>
          <DialogContent>
            <DialogContentText>
              Please fill in all appropraite filds to Edit your project
            </DialogContentText>
            <Box component="form" onSubmit={handleEditProjectSubmit}>
              <Paper p={2} elevation={2}>
                <Box sx={{ p: 2 }}>
                  <Box py={2}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <AccountCircle
                            sx={{ color: "action.active", mr: 1, my: 0.5 }}
                          />
                          <TextField
                            //   id="input-with-sx"
                            label="Project Name"
                            variant="standard"
                            name="project"
                            onChange={handleEditProjectChange}
                            value={editLogs.project || ""}
                            fullWidth
                            helperText={errors?.project}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <AccountCircle
                            sx={{ color: "action.active", mr: 1, my: 0.5 }}
                          />
                          <TextField
                            id="input-with-sx"
                            label="Tech Stack"
                            variant="standard"
                            name="tech_stack"
                            value={editLogs?.tech_stack}
                            fullWidth
                            onChange={handleEditProjectChange}
                            helperText={errors?.tech_stack}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <AccountCircle
                            sx={{ color: "action.active", mr: 1, my: 0.5 }}
                          />
                          <TextField
                            //   id="input-with-sx"
                            label="live link "
                            variant="standard"
                            name="live_link"
                            fullWidth
                            type="url"
                            value={editLogs.live_link}
                            onChange={handleEditProjectChange}
                            helperText={errors?.live_link}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <AccountCircle
                            sx={{ color: "action.active", mr: 1, my: 0.5 }}
                          />
                          <TextField
                            //   id="input-with-sx"
                            label="github link"
                            variant="standard"
                            name="github_link"
                            fullWidth
                            type="url"
                            value={editLogs.github_link}
                            onChange={handleEditProjectChange}
                            helperText={errors?.github_link}
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <AccountCircle
                            sx={{ color: "action.active", mr: 1, my: 0.5 }}
                          />
                          <TextField
                            //   id="input-with-sx"
                            label="project cover picture"
                            variant="standard"
                            name="project_cover"
                            fullWidth
                            type="url"
                            onChange={handleEditProjectChange}
                            value={editLogs.project_cover}
                            helperText={errors?.project_cover}
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          // id="filled-textarea"
                          label="project discription"
                          placeholder="enter description"
                          multiline
                          rows={8}
                          variant="filled"
                          name="description"
                          fullWidth
                          value={editLogs.description}
                          onChange={handleEditProjectChange}
                          helperText={errors?.description}
                        />
                      </Grid>
                      <TextField type="hidden" name="id" value={editLogs.id} />
                    </Grid>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Button variant="outlined" size="large" type="submit">
                      Edit Project
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseEdit} color="error" variant="outlined">
              close
            </Button>
          </DialogActions>
        </Container>
      </SwipeableDrawer>
    </>
  );
};

export default Projects;
